import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { IconSparkles, IconHistory } from "@tabler/icons-react";

export function QuizLayout() {
	const { pathname } = useLocation();
	const navigate = useNavigate();

	const isHistory = pathname.startsWith("/quiz/history");
	const isDetail = pathname !== "/quiz/history" && isHistory;

	return (
		<div style={{ display: "grid", gap: "0.75rem" }}>
			{!isDetail && (
				<div
					style={{
						display: "flex",
						gap: "0.35rem",
						padding: 2,
						borderRadius: "var(--radius-full)",
						background: "var(--color-surface-2)",
					}}
				>
					<button
						type="button"
						onClick={() => navigate("/quiz")}
						style={{
							flex: 1,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							gap: "0.35rem",
							padding: "0.55rem 0",
							borderRadius: "var(--radius-full)",
							border: "none",
							cursor: "pointer",
							fontSize: "0.82rem",
							fontWeight: 600,
							transition: "all 200ms ease",
							background: !isHistory ? "var(--color-primary)" : "transparent",
							color: !isHistory ? "#fff" : "var(--color-muted)",
							boxShadow: !isHistory
								? "0 1px 3px rgba(0,0,0,0.08)"
								: "none",
						}}
					>
						<IconSparkles size={14} /> Kuis
					</button>
					<button
						type="button"
						onClick={() => navigate("/quiz/history")}
						style={{
							flex: 1,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							gap: "0.35rem",
							padding: "0.55rem 0",
							borderRadius: "var(--radius-full)",
							border: "none",
							cursor: "pointer",
							fontSize: "0.82rem",
							fontWeight: 600,
							transition: "all 200ms ease",
							background: isHistory ? "var(--color-primary)" : "transparent",
							color: isHistory ? "#fff" : "var(--color-muted)",
							boxShadow: isHistory
								? "0 1px 3px rgba(0,0,0,0.08)"
								: "none",
						}}
					>
						<IconHistory size={14} /> History
					</button>
				</div>
			)}
			<Outlet />
		</div>
	);
}
